export const GET_DATA_MODULES = 'GET_DATA_MODULES'
export const LOADING_DATA_MODULES = 'LOADING_DATA_MODULES'